import { DialogActions as MuiIDialogActions, DialogActionsProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type { DialogActionsProps };

export const DialogActions: React.ComponentType<DialogActionsProps> = styled(
  MuiIDialogActions,
)<DialogActionsProps>(() => ({
  padding: '16px 24px 0 24px',
}));
